export default __webpack_public_path__ + "static/thumbnail2-d8671e1ddd3d827f40125aa5404002ff.jpg";